import styles from '../style.module.scss';
import moment from 'moment';
import api from 'helpers/api';

const SingleLog = ({refresh, log, setIsEditing, setIsCreatingNew, userRole}) => {

    const deleteLog = async (id) => {
        refresh()
        try {
            await api.delete(`/changelog/${id}`);
        } catch(e) {

        } finally {
            setIsEditing(null)
            refresh()
        }
    }

    return (
        <>
            <div logId={ log.id } className={[styles.logCard, styles.logCardFull].join(' ')}>
                <div className='d-flex align-items-center' style={{gap: '10px'}}>
                    <span>{ moment(log.created_at).format('MMMM DD, YYYY') }</span>
                    {userRole === 5 && !log.published && <span style={{color: 'red'}}>Not Published</span>}
                    { userRole === 5 && <div className='d-flex align-items-center' style={{
                        marginLeft: 'auto',
                        gap: '10px'
                    }}>
                        <button onClick={(e) => {
                            setIsEditing(log)
                            setIsCreatingNew(false)
                        }} className='link-button button-small p-0'>Edit</button>

                        /

                        <button onClick={(e) => {
                            deleteLog(log.id)
                        }} className='link-button button-small p-0'>Delete</button>
                    </div>}
                </div>
                <a href="#"><h3>{ log.title }</h3></a>
                <div className={ styles.logContent } dangerouslySetInnerHTML={ { __html: log.content } }>
                </div>
            </div>
        </>
    )
}

export default SingleLog;